import React, {memo, useState, useMemo, useRef, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import OtherAboveFold from '../../components/OtherAboveFold';
import DomesticOverseasTour from '../../components/DomesticOverseasTour';
import BannerMore from '../../components/BannerMore';
import ThemeTour from '../../components/ThemeTour';
import * as TYPES from '../../models/types';
import { isMath, getClientRect, delay } from '../../utils';

import styles from './styles.module.scss';

// banner
import bannerImg_1 from '../../assets/img/travelmall/banner/travelmall_1.jpg';
import bannerImg_2 from '../../assets/img/travelmall/banner/travelmall_2.jpg';
import bannerImg_3 from '../../assets/img/travelmall/banner/travelmall_3.jpg';
import bannerImg_4 from '../../assets/img/travelmall/banner/travelmall_4.jpg';
import bannerImg_5 from '../../assets/img/travelmall/banner/travelmallM.jpg';
import svgTitle from '../../assets/img/travelmall/banner/traveImallTitle.svg';
import svgMTitle from '../../assets/img/travelmall/banner/traveImallMTitle.svg';
import moreBannerImg from '../../assets/img/travelmall/banner/morebanner.jpg';
import moreBannerMImg from '../../assets/img/travelmall/banner/morebannerm.jpg';


const Index = memo(() => {
  const dispatch = useDispatch();
  const { decrementCrossBorderPositioning } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const { travelMall: { domesticTour, overseasTour, inclusiveAll, themeTour, bannerBtnText}} = useSelector(({localesReducer}) => localesReducer.i18n);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);
  const jumpPositioningReducer = useSelector(({jumpPositioningReducer}) => jumpPositioningReducer);
  const [bannerImg,  setBannerImg] = useState(bannerImg_1);

  const [innerContentHeight,  setInnerContentHeight] = useState(2120);
  const [innerContentPaddingTop,  setInnerContentPaddingTop] = useState(2120);
  const [svgWidth,  setSvgWidth] = useState(909.21);
  const [svgHeight,  setHeight] = useState(199.69);
  const [otherMarginTitleBot,  setOtherMarginTitleBot] = useState(20.31);



  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setBannerImg(bannerImg_1);
      setInnerContentHeight(2120);
      setInnerContentPaddingTop(455.56);
      setOtherMarginTitleBot(20.31);
      setSvgWidth(909.21);
      setHeight(199.69);
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setBannerImg(bannerImg_2);
      setInnerContentHeight(1852);
      setInnerContentPaddingTop(340.48);
      setOtherMarginTitleBot(14.7);
      setSvgWidth(679.52);
      setHeight(149.24);
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setBannerImg(bannerImg_3);
      setInnerContentHeight(1649);
      setInnerContentPaddingTop(255.36);
      setOtherMarginTitleBot(11.03);
      setSvgWidth( 509.64);
      setHeight(111.93);
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setBannerImg(bannerImg_4);
      setInnerContentHeight(1304);
      setInnerContentPaddingTop(221.59);
      setOtherMarginTitleBot(8.04);
      setSvgWidth(362.41);
      setHeight(79.6);
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setBannerImg(bannerImg_5);
      setInnerContentHeight(1440);
      setInnerContentPaddingTop(391.33);
      setOtherMarginTitleBot(32.67);
      setSvgWidth(521.5);
      setHeight(115.33);
      return styles.normalSm;
    }
  }, [recReSizeReducer]);



  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;
  const translateScaleStart = `scale(1.5)`;
  const translateScaleEnd = `scale(1)`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedScaleStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateScaleStart,
  };
  // 位移加透明度 end

  // TODO: onePage start
  const oneAnimatedScreenRef = useRef(null);
  const [oneAnimatedScreenFlag, setOneAnimatedScreenFlag] = useState(true);
  const [oneAnimatedScreenStyle, setOneAnimatedScreenStyleApi] = useState(initFedScaleStart);
  const oneAnimatedScreenScroll = () => {
      if (oneAnimatedScreenFlag) {
        setOneAnimatedScreenStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateScaleStart,
        });
      }else{
        setOneAnimatedScreenStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateScaleEnd,
        });
      }
  }
  // TODO: onePage end

  // TODO: twoPage start
  const twoAnimatedTextRef = useRef(null);
  const twoAnimatedCardRef = useRef(null);
  const [twoAnimatedTextStyle, setTwoAnimatedTextStyleApi] = useState(initFedStart);
  const [twoAnimatedCardStyle, setTwoAnimatedCardStyleApi] = useState(initFedStart);

  const twoAnimatedTexScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setTwoAnimatedTextStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setTwoAnimatedTextStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
    }
    const twoAnimatedCardScroll = (curEle, num) => {
        let { isClientRect } = getClientRect(curEle, num); // 当前元素
        if (isClientRect) {
          setTwoAnimatedCardStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setTwoAnimatedCardStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const twoAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            twoAnimatedTexScroll(twoAnimatedTextRef);
            twoAnimatedCardScroll(twoAnimatedCardRef, 990);
        }else{
            // H5
            twoAnimatedTexScroll(twoAnimatedTextRef);
            twoAnimatedCardScroll(twoAnimatedCardRef, 1846);
        }
    }
  
    // TODO: twoPage end


    // TODO: threePage start
    const threeAnimatedTextRef = useRef(null);
    const threeAnimatedCardRef = useRef(null);
    const [threeAnimatedTextStyle, setThreeAnimatedTextStyleApi] = useState(initFedStart);
    const [threeAnimatedCardStyle, setThreeAnimatedCardStyleApi] = useState(initFedStart);

    const threeAnimatedTexScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setThreeAnimatedTextStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setThreeAnimatedTextStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }
    const threeAnimatedCardScroll = (curEle, num) => {
        let { isClientRect } = getClientRect(curEle, num); // 当前元素
        if (isClientRect) {
          setThreeAnimatedCardStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setThreeAnimatedCardStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    } 

    const threeAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            threeAnimatedTexScroll(threeAnimatedTextRef);
            threeAnimatedCardScroll(threeAnimatedCardRef, 990);
        }else{
            // H5
            threeAnimatedTexScroll(threeAnimatedTextRef);
            threeAnimatedCardScroll(threeAnimatedCardRef, 1938);
        }
    }
    // TODO: threePage end

    // TODO: fourPage start
    const fourAnimatedTextRef = useRef(null);
    const fourAnimatedBgRef = useRef(null);
    const [fourAnimatedTextStyle, setFourAnimatedTextStyleApi] = useState(initFedStart);
    const [fourAnimatedBgStyle, setFourAnimatedBgStyleApi] = useState(initFedStart);

    const fourAnimatedTextScroll = (curEle) => {
        let { isClientRect } = getClientRect(curEle); // 当前元素
        if (isClientRect) {
          setFourAnimatedTextStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFourAnimatedTextStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fourAnimatedBgScroll = (curEle, num) => {
        let { isClientRect } = getClientRect(curEle, num); // 当前元素
        if (isClientRect) {
          setFourAnimatedBgStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setFourAnimatedBgStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
    }

    const fourAnimateScroll = () => {
        if(recReSizeReducer > 750){
            // PC
            fourAnimatedTextScroll(fourAnimatedTextRef);
            fourAnimatedBgScroll(fourAnimatedBgRef, 700);
        }else{
            // H5
            fourAnimatedTextScroll(fourAnimatedTextRef);
            fourAnimatedBgScroll(fourAnimatedBgRef, 520);
        }
    }

    // TODO: fourPage end

    // TODO: fivesPage start
    const fivesAnimatedTextRef = useRef(null);
    const fivesAnimatedCardRef = useRef(null);
    const [fivesAnimatedTextStyle, setFivesAnimatedTextStyleApi] = useState(initFedStart);
    const [fivesAnimatedCardStyle, setFivesAnimatedCardStyleApi] = useState(initFedStart);

    const fivesAnimatedTexScroll = (curEle) => {
      let { isClientRect } = getClientRect(curEle); // 当前元素
      if (isClientRect) {
        setFivesAnimatedTextStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setFivesAnimatedTextStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  }
  const fivesAnimatedCardScroll = (curEle, num) => {
      let { isClientRect } = getClientRect(curEle, num); // 当前元素
      if (isClientRect) {
        setFivesAnimatedCardStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateYStart,
        });
        
      }else{
        setFivesAnimatedCardStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateYEnd,
        });
        
      }
  } 

  const fivesAnimateScroll = () => {
      if(recReSizeReducer > 750){
          // PC
          fivesAnimatedTexScroll(fivesAnimatedTextRef);
          fivesAnimatedCardScroll(fivesAnimatedCardRef, 900);
      }else{
          // H5
          fivesAnimatedTexScroll(fivesAnimatedTextRef);
          fivesAnimatedCardScroll(fivesAnimatedCardRef, 1546);
      }
  }

    // TODO: fivesPage end

    useEffect(() => {
      setOneAnimatedScreenFlag(false);
  
      delay(1000, () => {
        oneAnimatedScreenScroll();
      });
    }, [oneAnimatedScreenFlag]);


    useEffect(() => {
      twoAnimateScroll(); // twoPage
      threeAnimateScroll(); // threePage
      fourAnimateScroll(); // threePage
      fivesAnimateScroll(); // threePage
    }, [scrolVal]);


    const handleChangeJump = () => {
      // 定位跳转
      if(jumpPositioningReducer.crossBorderName){
        document.querySelector(`#${jumpPositioningReducer.crossBorderName}`).scrollIntoView(true); 
      }
      
    };

    useEffect(() => {
      handleChangeJump();
      
      return () => {
        dispatch(decrementCrossBorderPositioning());
      }
    }, []);


  return (
        <div className={normal}>
            <div 
              className="onePage"
              ref={oneAnimatedScreenRef}
              style={oneAnimatedScreenStyle}
            >
              <OtherAboveFold
                  config={{
                    bgImg: bannerImg,
                    svgTitle: recReSizeReducer <= 750 ? svgMTitle : svgTitle,
                    title: '旅行商城',
                    innerContentStyles: {
                      width: `100%`,
                      height: isMath(recReSizeReducer,innerContentHeight),
                      paddingTop: isMath(recReSizeReducer,innerContentPaddingTop),
                    },
                    otherStyle: {
                      svgTitleCss: {
                        width: isMath(recReSizeReducer,svgWidth),
                        height: isMath(recReSizeReducer,svgHeight),
                        margin: `0 auto ${isMath(recReSizeReducer,otherMarginTitleBot)} auto`, //
                      }
                    }

                  }}
              />
            </div>
            <div 
              className="twoPage"
              name={'domestiTour'} 
              id={'domestiTour'}
            >
              <DomesticOverseasTour
                  config={{
                    getRefs: {
                      innerTextRef: twoAnimatedTextRef,
                      innerTextStyles: twoAnimatedTextStyle,
                      innerCardRef: twoAnimatedCardRef,
                      innerCardStyles: twoAnimatedCardStyle,
                    },
                    data: domesticTour,
                    inclusiveAll,
                    type: TYPES.domesticTourType,
                  }}
              />
            </div>
            <div 
              className="threePage"
              name={'overseasTour'} 
              id={'overseasTour'}
            >
              <DomesticOverseasTour
                  config={{
                    getRefs: {
                      innerTextRef: threeAnimatedTextRef,
                      innerTextStyles: threeAnimatedTextStyle,
                      innerCardRef: threeAnimatedCardRef,
                      innerCardStyles: threeAnimatedCardStyle,
                    },
                    data: overseasTour,
                    inclusiveAll,
                    type: TYPES.overseasTourType,
                  }}
              />
            </div>
            <div className="fourPage">
              <BannerMore
                  config={{
                    getRefs: {
                      innerTextRef: fourAnimatedTextRef,
                      innerTextStyles: fourAnimatedTextStyle,
                      innerBgRef: fourAnimatedBgRef,
                      innerBgStyles: fourAnimatedBgStyle,
                    },
                    bgImg: recReSizeReducer <= 750 ? moreBannerMImg : moreBannerImg,
                    title: bannerBtnText,
                  }}
              />
            </div>
            <div className="fivesPage">
              <ThemeTour
                  config={{
                    getRefs: {
                      innerTextRef: fivesAnimatedTextRef,
                      innerTextStyles: fivesAnimatedTextStyle,
                      innerCardRef: fivesAnimatedCardRef,
                      innerCardStyles: fivesAnimatedCardStyle,
                    },
                    data: themeTour,
                  }}
              />
            </div>
            
           {/*  <div className="sixPage">
              <ServerGroup />
              <CustomizeTravelBtn
                  config={{
                    title: customizationProcessData.btnText,
                    handleEvent: () => {
                      dispatch(basicOtherModelrEvent({
                        otherVisible: TYPES.OTHERDRAWERSHOW,
                        otherOptions: {
                          status: 0,
                        },
                      }));
                    }
                  }}
              />
            </div> */}
            
        </div>
       
  );
});
export default Index;